module.exports = __webpack_public_path__ + "static/media/0072_Small.042ed770.jpg";